import React from "react"
import {Box} from "@mui/material";

const TreeInfoContactView = (props) => {

    return (
        <Box>相談記録</Box>
    )
}

export default TreeInfoContactView
